import VueTypes from 'vue-types';

export default {
  name: VueTypes.string.isRequired,
};
